module.exports = __webpack_public_path__ + "img/loginBg.108c4d9e.png";